import { helpers, required, requiredIf } from '@vuelidate/validators';
import LOCALIZATION from '../Localization';
import util from '@core/services/util';

export default class ApplicationsResidenceStatus {
	constructor(init) {
		this.status = null; // Possible Values: mortgage, rental, own, familyOther
		this.paymentAmount = null;
		this.paymentIncludesInsurance = null;
		this.insuranceFrequency = null; // Possible Values: monthly, annually
		this.insuranceAmount = null;
		this.paymentIncludesTax = null;
		this.taxFrequency = null; // Possible Values: monthly, annually
		this.taxAmount = null;
		this.sharedWith = null; // Possible Values: parent, sibling, other
		this.explainStatus = null;

		if (init) {
			this.status = init.status;
			this.paymentAmount = init.paymentAmount;
			this.paymentIncludesInsurance = init.paymentIncludesInsurance;
			this.insuranceFrequency = init.insuranceFrequency;
			this.insuranceAmount = init.insuranceAmount;
			this.paymentIncludesTax = init.paymentIncludesTax;
			this.taxFrequency = init.taxFrequency;
			this.taxAmount = init.taxAmount;
			this.sharedWith = init.sharedWith;
			this.explainStatus = init.explainStatus;
		}
	}

	getStatusProperCase() {
		return util.toProperCase(this.status);
	}

	validation(language = 'English') {
		const requiredWithMessage = message => helpers.withMessage(message, required);
		const requiredIfWithMessage = (message, condition) => helpers.withMessage(message, requiredIf(condition));

		return {
			status: {
				required: requiredWithMessage(LOCALIZATION.generalMessages.radioQuestionRequired[language]),
			},
			paymentAmount: {
				required: requiredIfWithMessage(
					LOCALIZATION.customerPortalResidenceStatus.paymentRequired[language],
					() => this.status !== null && this.status !== 'own',
				),
			},
		};
	}
}
